import DictionaryTypes from '../../models/dictionary-types';
import Subjects from '../../models/subjects';
import { SelectorStore } from './selector-store';

export default class NumberInKimFilter extends SelectorStore {

    constructor(subject: Subjects, multiple?: boolean) {
        super(subject, DictionaryTypes.numbersInKim, multiple);
    }
}

